import React, { forwardRef, useCallback } from 'react'

import phone from 'phone'
import PhoneNumberInput, { PhoneInputProps } from 'react-phone-number-input'

const PhoneInput = forwardRef<PhoneNumberInput, PhoneInputProps>(({ onChange, ...props }, ref) => {
  const handleChange = useCallback(
    (value: string) => {
      const [phoneNumber] = phone(value)
      onChange(phoneNumber || value)
    },
    [onChange],
  )

  return <PhoneNumberInput ref={ref} onChange={handleChange} {...props} />
})

PhoneInput.displayName = 'PhoneInput'

export default PhoneInput
